const UTF8_BOM = '﻿';

function escapeField(value) {
  if (value === null || value === undefined) return '';
  let str;
  if (value instanceof Date) {
    str = value.toISOString();
  } else if (typeof value === 'boolean') {
    str = value ? 'true' : 'false';
  } else if (typeof value === 'object') {
    try { str = JSON.stringify(value); } catch { str = String(value); }
  } else {
    str = String(value);
  }

  const needsQuotes = /[",\r\n]/.test(str) || /^\s/.test(str);
  if (!needsQuotes) return str;
  return `"${str.replace(/"/g, '""')}"`;
}

export function toCsv(rows, columns) {
  if (!Array.isArray(columns) || columns.length === 0) return UTF8_BOM;
  const header = columns.map(c => escapeField(c.header ?? c.key)).join(',');
  const body = (rows || []).map(row =>
    columns.map(c => {
      const raw = row?.[c.key];
      const formatted = typeof c.format === 'function' ? c.format(raw, row) : raw;
      return escapeField(formatted);
    }).join(',')
  );
  return UTF8_BOM + [header, ...body].join('\r\n');
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
